export default __webpack_public_path__ + "static/media/scrollIndicator.1ab207cc.svg";